import styled from 'styled-components';

import Image from '@nubank/www-latam-commons/components/Image/Image';

export const StyledImage = styled(Image)`
  width: 100%;
  max-height: calc(100vh - 20rem);
  object-fit: cover;
`;

StyledImage.displayName = 'StyledImage';

export const BlockImage = styled(Image)`
  display: block;
`;

BlockImage.displayName = 'BlockImage';

